import { AccountDataType } from '../types';

const selectAccountUrl = '/facade/api/AccountSelector/SelectAccount';
const getResiAccountsUrl = '/facade/api/AccountSelector/GetResiAccounts';

const selectAccount = async (accountNum: string, jurisdiction: string, endpoint?: string) => {
  const postData = {
    accountNum,
    jurisdiction,
  };
  let response;
  let data;

  try {
    const url = endpoint || selectAccountUrl;
    response = await fetch(url, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData),
    });
    data = await response?.json();
  } catch (e: any) {
    throw new Error(`${(e?.message, data?.ReturnCode || e)}`);
  }

  if (data === undefined || data.Status !== 'Success') {
    throw new Error(`Error selecting account, ${data.ReturnCode}`);
  }

  return data;
};

const getAccounts = async (endpoint?: string) => {
  const postData = {
    email: '',
  };
  let response;
  let data: AccountDataType | null = null;

  try {
    const url = endpoint || getResiAccountsUrl;
    response = await fetch(url, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData),
    });
    data = await response?.json();
  } catch (e: any) {
    throw new Error(`${e?.message}, ${data?.ReturnCode}`);
  }
  if (data === undefined || data?.Status !== 'Success') {
    throw new Error(`Error fetching account, ${data?.ReturnCode}`);
  }

  return data;
};

export { getAccounts, selectAccount };
